/**
 * Generic modal component. Uses CSSTransitionGroup to animate entry (which
 * is configurable), and renders a modal header and modal body wrapped in a card
 * of a given size as passed in via props
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// import third-party libraries
import classNames from 'classnames';

// import components
import Base from '../BaseComponent.js.jsx';

class Modal extends Base {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      btnColor
      , bodyClasses
      , cardSize
      , closeAction
      , closeText
      , confirmAction
      , confirmText
      , disableConfirm
      , footerClasses
      , headerStyle
      , isOpen
      , modalClasses
      , modalHeader
      , showButtons
      , showClose
      , showConfirm
      , showTopButtons
    } = this.props;
    // console.log(isOpen)
    const topClass = classNames(
      'topbar'
    )
    const confirmBtnClass = classNames(
      'yt-btn'
      , 'slp'
    )

    const closeBtnClass = classNames(
      'close-btn u-pullRight'
      , modalClasses
    )

    const linkBtnClass = classNames(
      'yt-btn'
      , 'link'
      , btnColor
    )

    const modalClass = classNames(
      'standard-modal'
      , modalClasses
    )

    const colClass = classNames(
      'yt-col'
      , 'full'
      , {
        's_75 m_40 l_25 xl_20':  cardSize === 'small'
        , 's_75 m_50 l_33 xl_25': !cardSize || cardSize === 'standard'
        , 's_75 m_55 l_40 xl_33': cardSize === 'medium'
        , 's_75  l_50': cardSize === 'large'
        , 's_80': cardSize === 'jumbo'
      }
    )

    const bodyClass = classNames(
      'card-body'
      , bodyClasses
    )

    const footerClass = classNames(
      'card-footer'
      , footerClasses
    )

    /**
     * This conditional tells the HTML <body> that there is a modal open, so we
     * should prevent scrolling
     */
    if(isOpen) {
      document.body.classList.toggle('modal-open', true);
    } else {
      document.body.classList.toggle('modal-open', false);
    }

    return (
      <TransitionGroup>
        {isOpen ?
          <CSSTransition
            timeout={500}
            classNames="modal-anim"
          >
            <div className={modalClass}>
              <div className={colClass}>
                <div className="card">
                  <div className="card-header" style={headerStyle}>
                    {modalHeader}
                    <button className={closeBtnClass} onClick={()=>closeAction()}>
                      <i className="ion ion-close-round" />
                    </button>
                  </div>
                  { showTopButtons && showButtons ?
                    <div className="card-footer">
                      <div className="yt-row space-between">
                        { closeText && showClose ?
                          <button type="button" className={linkBtnClass} onClick={()=> closeAction()}>{closeText}</button>
                          :
                          <div/>
                        }
                        { confirmAction && showConfirm ?
                          <div className="-buttons">
                            <button type="button" className={confirmBtnClass} onClick={()=> confirmAction()} disabled={disableConfirm}>{confirmText}</button>
                          </div>
                          :
                          <div/>
                        }
                      </div>
                    </div>
                    :
                    null
                  }
                  <div className={bodyClass}>
                    {this.props.children}
                  </div>
                  { showButtons ?
                    <div className={footerClass}>
                      <div className="yt-row space-between">
                        { closeText && showClose ?
                          <button type="button" className={linkBtnClass} onClick={()=> closeAction()}>{closeText}</button>
                          :
                          <div/>
                        }
                        { confirmAction && showConfirm ?
                          <button type="button" className={confirmBtnClass} onClick={()=> confirmAction()} disabled={disableConfirm}>{confirmText}</button>
                          :
                          <div/>
                        }
                      </div>
                    </div>
                    :
                    null
                  }
                </div>
              </div>
            </div>
          </CSSTransition>
          :
          null
        }
      </TransitionGroup>
    )
  }
}

Modal.propTypes = {
  btnColor: PropTypes.string
  , cardSize: PropTypes.oneOf(['small', 'standard', 'large', 'jumbo'])
  , closeAction: PropTypes.func.isRequired
  , closeText: PropTypes.string
  , confirmAction: PropTypes.func
  , confirmText: PropTypes.string
  , disableConfirm: PropTypes.bool
  , headerStyle: PropTypes.any
  , isOpen: PropTypes.bool.isRequired
  , modalHeader: PropTypes.any
  , modalClasses: PropTypes.string
  , showButtons: PropTypes.bool
  , showClose: PropTypes.bool
  , showConfirm: PropTypes.bool
}

Modal.defaultProps = {
  btnColor: 'info'
  , cardSize: 'standard'
  , closeText: 'Close'
  , confirmAction: null
  , disableConfirm: false
  , headerStyle: null
  , modalHeader: null
  , modalClasses: 'info'
  , showButtons: true
  , showClose: true
  , showConfirm: true
}

export default Modal;



// WEBPACK FOOTER //
// global/components/modals/Modal.js.jsx